import paymentTypes from './paymentTypes'
import moment from 'moment'

export const initialState = {
  filters: {
    LastModifiedDateFrom: moment().subtract(1, 'days').format('YYYY-MM-DD'),
    UploadedDateFrom: '',
    UploadedDateTo: '',
    InvoiceStatusID: ''
  },
  loadPage: false,
  error: '',
  payments: [],
  payoutTermsTypes: []
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case paymentTypes.GET_PAYMENTS:
      return {
        ...state,
        loadPage: true,
        error: ''
      }

    case paymentTypes.GET_PAYMENTS_SUCCESS: {
      return {
        ...state,
        payments: payload,
        loadPage: false,
        error: ''
      }
    }

    case paymentTypes.GET_PAYMENTS_FAILURE: {
      return {
        ...state,
        loadPage: false,
        error: payload,
        payments: []
      }
    }

    case paymentTypes.CLEAR_PAYMENTS: {
      return {
        ...state,
        loadPage: true
      }
    }

    case paymentTypes.SET_FILTERS : {
      const filters = (!payload) ? { ...initialState.filters } : {
        ...state.filters,
        ...payload,
        offset: 0
      }

      return {
        ...state,
        filters,
        loadPage: true
      }
    }

    case paymentTypes.GET_PAYOUT_TERMS_TYPES_SUCCESS: {
      return {
        ...state,
        payoutTermsTypes: payload
      }
    }

    case paymentTypes.GET_PAYOUT_TERMS_TYPES_FAILURE: {
      return {
        ...state,
        error: payload,
        payoutTermsTypes: []
      }
    }

    default: return state
  }
}
